import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';

// --- Components & Styles ---
import "../Styles/CustomerView.css"; // New stylesheet
const API_URL = process.env.REACT_APP_API_URL;
const CustomerView = () => {
    const { customercode } = useParams();
    const [customer, setCustomer] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    // BUG FIX: Add auth token to API call
    const token = localStorage.getItem("token");
    const headers = useMemo(() => ({ Authorization: `Bearer ${token}` }), [token]);

    useEffect(() => {
        if (!token) {
            navigate("/login");
            return;
        }
        // BUG FIX: Added 'headers' to the GET request
        axios.get(`${API_URL}/customers/${customercode}`, { headers })
            .then(res => setCustomer(res.data))
            .catch((err) => {
                if(err.response?.status === 401) navigate("/login");
                else toast.error("Customer not found");
            })
            .finally(() => setLoading(false));
    }, [customercode, headers, navigate, token]);

    if (loading || !customer) {
        return <p style={{ textAlign: "center", padding: "2rem" }}>Loading Customer...</p>;
    }

    // Helper to format the address
    const fullAddress = [customer.address1, customer.address2, customer.city, customer.state]
        .filter(Boolean) // Remove empty or null parts
        .join(', ') + (customer.pincode ? ` - ${customer.pincode}` : '');

    return (
        <>
            <div className="view-container">
                <div className="view-header">
                    <h3>{customer.customername}</h3>
                    <span className="customer-code">Code: {customer.customercode}</span>
                </div>
                <div className="view-details-grid">
                    <div className="detail-item">
                        <label>Address</label>
                        <p>{fullAddress || "-"}</p>
                    </div>
                    <div className="detail-item">
                        <label>GST Number</label>
                        <p>{customer.tinno || "N/A"}</p>
                    </div>
                    <div className="detail-item">
                        <label>Mobile</label>
                        <p>{customer.mobile || "N/A"}</p>
                    </div>
                    <div className="detail-item">
                        <label>Email</label>
                        <p>{customer.email || "N/A"}</p>
                    </div>
                </div>
                <div className="view-footer">
                    <button className="btn btn-outline" onClick={() => navigate(-1)}>Back</button>
                    <button className="btn btn-primary" onClick={() => navigate(`/masters/customers/edit/${customer.customercode}`)}>Edit Customer</button>
                </div>
            </div>
        </>
    );
};

export default CustomerView;